// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interview-dates-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #006ee9;
}
.interview-dates-container .pagination-arrow-size {
  font-size: 1.5rem;
}
.interview-dates-container span {
  font-weight: bold;
  min-width: 70px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./../interview/src/components/InterviewCard/components/InterviewDates/InterviewDates.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AACF;AACE;EACE,iBAAA;AACJ;AAEE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AAAJ","sourcesContent":[".interview-dates-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  color: #006ee9;\n\n  .pagination-arrow-size {\n    font-size: 1.5rem;\n  }\n\n  span {\n    font-weight: bold;\n    min-width: 70px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
